import React, {
  createContext, useCallback, useContext, useMemo, useState,
} from 'react';

const ChessCoachContext = createContext(null);

export function ChessCoachProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const [gameContext, setGameContextState] = useState(null);

  const openCoach = useCallback((ctx = null) => {
    if (ctx && (ctx.gameId != null || ctx.focusPly != null)) {
      setGameContextState({
        gameId: ctx.gameId ?? null,
        focusPly: ctx.focusPly ?? null,
      });
    }
    setIsOpen(true);
  }, []);

  const closeCoach = useCallback(() => {
    setIsOpen(false);
  }, []);

  const toggleCoach = useCallback(() => {
    setIsOpen((v) => !v);
  }, []);

  const setGameContext = useCallback((ctx) => {
    setGameContextState(ctx ? {
      gameId: ctx.gameId ?? null,
      focusPly: ctx.focusPly ?? null,
    } : null);
  }, []);

  const clearGameContext = useCallback(() => {
    setGameContextState(null);
  }, []);

  const value = useMemo(() => ({
    isOpen,
    openCoach,
    closeCoach,
    toggleCoach,
    gameContext,
    setGameContext,
    clearGameContext,
  }), [
    isOpen,
    openCoach,
    closeCoach,
    toggleCoach,
    gameContext,
    setGameContext,
    clearGameContext,
  ]);

  return (
    <ChessCoachContext.Provider value={value}>
      {children}
    </ChessCoachContext.Provider>
  );
}

export function useChessCoach() {
  const ctx = useContext(ChessCoachContext);
  if (!ctx) {
    throw new Error('useChessCoach must be used within ChessCoachProvider');
  }
  return ctx;
}
